import { useMemo } from "react";
import { getPortfolioReportingSummaryQuery } from "web_myplann/Api/Portfolio/Queries/getPortfolioReportingSummaryQuery";
import { usePortfolioListQuery } from "web_myplann/Api/Portfolio/Queries/usePortfolioListQuery";
import { usePropertyListQuery } from "web_myplann/Api/Portfolio/Queries/usePropertyListQuery";
import type { PortfolioReportingOverviewTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { getReportingPortfolioIds } from "web_myplann/Portfolio/Helpers/portfolioReportingDomains";

export const useDashboardDetailData = (
	overviewType: PortfolioReportingOverviewTypeEnum | undefined,
) => {
	const filterDatagroups = overviewType ? [overviewType] : undefined;
	const { data: portfolios, isLoading: isPortfoliosLoading } =
		usePortfolioListQuery(filterDatagroups, true, !!overviewType);
	const { data: properties, isLoading: isPropertiesLoading } =
		usePropertyListQuery(filterDatagroups, true, !!overviewType);

	const specialPortfolioListIds = useMemo(
		() => getReportingPortfolioIds(portfolios?.data ?? []),
		[portfolios?.data],
	);

	const { data: reporting, isLoading: isReportingLoading } =
		getPortfolioReportingSummaryQuery(
			specialPortfolioListIds,
			filterDatagroups,
		);

	const hasData = !!(portfolios?.data || properties?.data);
	const isLoading = (isPortfoliosLoading || isPropertiesLoading) && !hasData;
	const isAnyLoading =
		isPortfoliosLoading || isPropertiesLoading || isReportingLoading;

	return {
		portfolios,
		properties,
		reporting,
		isLoading,
		isAnyLoading,
	};
};
